import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, ProgressBar, Spinner, Switch } from 'components/base';
import SignInWithAncestry from 'ecommerce/components/signInWithAncestry';
import { formatDuration } from 'utils/format';

import ancestorsApi from '../../api/ancestors';
import SETTINGS from '../../settings';
import { getDirectionFromTreeType } from '../../api/generator';
import SignInWithFamilySearch from 'ecommerce/components/signInWithFamilySearch';

const AncestryWebSocketSynchronizer = props => {
  const [isSynchronizing, setIsSynchronizing] = useState(false);
  const [value, setValue] = useState(0);

  const [lastSyncDate, setLastSyncDate] = useState();
  const [useForceUpdate, setUseForceUpdate] = useState(false);

  const [authorized, setAuthorized] = useState();

  const [progressLabel, setProgressLabel] = useState(props.initialProgressLabel || props.progressLabel);

  useEffect(() => {
    if (props.ancestryAuth) {
      (async () => {
        const { error } = await props.ancestryAuth.getToken(props.type);
        if (error) {
          setAuthorized(false);
        } else {
          setAuthorized(true);
        }
      })();
    } else {
      setAuthorized(true);
    }
  }, [props.ancestryAuth, props.type]);

  const onProgress = val => {
    setIsSynchronizing(true);
    setValue(val);
  };

  const startGenerator = async () => {
    await props.onSuccess({ onProgress, close: props.close });
    props.close();
  };

  useEffect(() => {
    if (authorized) {
      // Start generator 
      startGenerator();

      // OLD APPROACH WITH FORCE UPDATE
      // if (props.checkSyncStatusFirst) {
      //   (async () => {
      //     const { data: syncStatusData } = await ancestorsApi(props.type, props.accessToken).syncStatus(
      //       props.productId,
      //       props.treeName,
      //       props.persons,
      //       props.numberOfGenerations,
      //       getDirectionFromTreeType(props.treeType, props.productId),
      //     );

      //     if (syncStatusData) {
      //       if (syncStatusData.sync === 'none' && syncStatusData.updated_at) {
      //         //
      //         // DEBUG
      //         //
      //         // Use cached data by default
      //         if (SETTINGS.DEBUG) {
      //           startGenerator(false);
      //           return;
      //         }

      //         setLastSyncDate(formatDuration(new Date(syncStatusData.updated_at)));
      //         return;
      //       }
      //     }

      //     startGenerator(true);
      //   })();
      // } else {
      //   startGenerator(true);
      // }
    }
  }, [props.checkSyncStatusFirst, authorized]);

  useEffect(() => {
    if (props.onDelay) {
      props.onDelay(setProgressLabel);
    }
    // Only run on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (authorized === false) {
    if (props.type === "familysearch") {
      return (
        <>
          <p className="mb-3">
            Your connection to FamilySearch.com has expired.
            <br />
            Please click the button below to Sign back in to your FamilySearch account.
          </p>
          <SignInWithFamilySearch redirectUrl="referer" />
        </>
      );
    }
    return (
      <>
        <p className="mb-3">
          Your connection to Ancestry.com has expired.
          <br />
          Please click the button below to Sign back in to your Ancestry account.
        </p>
        <SignInWithAncestry redirectUrl="referer" />
      </>
    );
  }

  // if (lastSyncDate) {
  //   return (
  //     <>
  //       We already have data for the chosen person(s) from when you created your last project{' '}
  //       <strong>({lastSyncDate} ago)</strong>. If you have made changes since then, you might want
  //       to refresh this data.
  //       <br />
  //       <br />
  //       <small>Note: Checking this will increase the time taken to process your creation.</small>
  //       <br />
  //       <br />
  //       <Switch switchId="forceUpdate" checked={useForceUpdate} onChange={setUseForceUpdate}>
  //         <span className="ml-1">REFRESH WITH THE LATEST CHANGES ON {props.type.toUpperCase()}</span>
  //       </Switch>
  //       <br />
  //       <br />
  //       <Button
  //         type="secondary"
  //         onClick={() => {
  //           startGenerator(useForceUpdate);
  //           setLastSyncDate(null);
  //         }}
  //       >
  //         Continue
  //       </Button>
  //     </>
  //   );
  // }

  return (
    <div className="text-center">
      <div style={{ height: 60 }}>
        {isSynchronizing ? (
          <ProgressBar value={value} label={`${Math.round(value)}%`} />
        ) : (
          <Spinner />
        )}
      </div>
      {progressLabel}
      <br />
      This might take a few minutes.
    </div>
  );
};

AncestryWebSocketSynchronizer.propTypes = {
  type: PropTypes.string,
  ancestryAuth: PropTypes.object,
  accessToken: PropTypes.string,
  productId: PropTypes.string,
  treeName: PropTypes.string,
  persons: PropTypes.array,
  numberOfGenerations: PropTypes.number,
  treeType: PropTypes.string,
  onSuccess: PropTypes.func,
  checkSyncStatusFirst: PropTypes.bool,
  progressLabel: PropTypes.string,
  initialProgressLabel: PropTypes.string,
  onDelay: PropTypes.func,
};

AncestryWebSocketSynchronizer.defaultProps = {
  type: "ancestry",
  progressLabel: 'We\'re turning your data into a project preview.',
  initialProgressLabel: 'We\'re turning your data into a project preview.',
  checkSyncStatusFirst: false,
};

export default AncestryWebSocketSynchronizer;
